var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramStageTabM(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 68,
    viewBox: "0 0 64 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_524_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 20H39.5007V2.49933H24.4993V20H22V0H42V20Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0013 20.0001H34.502V7.87433H29.498V20.0001H26.9987V5.375H37.0013V20.0001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_524_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.209 25.1494H27.2512V42.8468H30.209V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.27 25.1494H35.3123V42.8468H38.27V25.1494Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6074 32.0114L28.254 34.8818L29.2092 37.701L37.5626 34.8305L36.6074 32.0114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8897 25.1729H13.5V28.1516H23.8897V25.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.176 26.6621H17.2183V42.8276H20.176V26.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1244 44L40.3169 33.3901L46.8239 24L49.2465 25.7021L43.9554 33.3381L50.5 42.2269L48.1244 44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3123 31.877H42.1385V34.8557H49.3123V31.877Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_524_14751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1623 67.6314L38.2997 59.0215L38.2477 57.2342L44.5143 48.3643L46.9453 50.0853L41.3219 58.038L46.1838 64.1373L49.154 59.4092L46.1413 59.6503L45.9048 56.681L51.8782 56.2082L53.2545 58.4825L47.5885 67.499L45.1623 67.6314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0742 66.8128L30.5764 54.2171L26.3245 66.7892L23.5057 65.8389L29.1244 49.21L30.3683 49.1958L31.9385 49.1816L37.8788 65.8105L35.0742 66.8128Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7628 61.6658L30.696 59.5996L28.6293 61.6658L30.696 63.7319L32.7628 61.6658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.91339 67.5507L1.08306 65.2056L5.29234 61.9195L0 55.4703L6.87201 48.4443L9.0003 50.5294L3.99172 55.6453L9.52527 62.3923L2.91339 67.5507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4369 49.1729H11.9705V52.1516H22.4369V49.1729Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6959 50.6621H15.7163V66.8276H18.6959V50.6621Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6069 68L53.7417 57.3901L60.2968 48L62.7373 49.7021L57.4118 57.3381L64.0001 66.2269L61.6069 68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8035 55.877H55.5768V58.8557H62.8035V55.877Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_524_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_524_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 20,
    fill: "white",
    transform: "translate(13.5 24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_524_14751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 20,
    fill: "white",
    transform: "translate(0 48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramStageTabM);
export default __webpack_public_path__ + "static/media/programStageTabM.72440e2507bdf32eb60f02c84bdd3ee4.svg";
export { ForwardRef as ReactComponent };